const cor = {
  uk: 'gb', tp: 'ie', cz: 'cs', ua: 'uk'
};

const preflang = {
  au: 'en', tp: 'en', al: 'en', in: 'en',
  cy: 'gr', az: 'ru', ca: 'us', cn: 'zs',
  cz: 'cs', jp: 'ja', ua: 'uk', uk: 'en'
};

function carStore({market, currency, translations}) {
  const data = {
    cor: market in cor ? cor[market] : market,
    preflang: market in preflang ? preflang[market] : market,
    prefcurrency: currency
  };

  const {main, seo, companies} = translations;

  return {
    searcMask: {
      data,
      translations: {...main}
    },
    seo: {
      translations: {...seo}
    },
    popularCompanies: {
      translations: {...companies}
    }
  };
}

export default carStore;
